import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-menu-burguer',
  imports: [],
  templateUrl: './icon-menu-burguer.component.html',
  styleUrl: './icon-menu-burguer.component.scss'
})
export class IconMenuBurguerComponent {

}
